import {DateRange} from 'common/widgets/date-range-picker/models/date-range';
import {BaseDate, DateRangeType, RelativeDate} from 'common/widgets/date-range-picker/models/types';

import {ComparisonDate, ComparisonDateRangeBookmarkFormat} from './types';

export function getRelativeDateFromComparisonDate(comparisonDate: ComparisonDate): RelativeDate {
  const date: BaseDate = comparisonDate.offset ?? comparisonDate.from ?? comparisonDate.to;
  if (DateRange.isRelativeDate(date)) {
    return date;
  }

  return DateRange.convertCalendarDateToRelativeDate(date);
}

export function getComparisonType(comparisonDate?: ComparisonDate) {
  //DateRangeType.EndsOn has a to date. Otherwise, it's StartsOn
  if (comparisonDate?.to) {
    return DateRangeType.EndsOn;
  }
  return DateRangeType.StartsOn;
}

// Why did we use from/to instead of from_date/to_date ?
export function comparisonDateToBookmarkFormat(comparisonDate: ComparisonDate): ComparisonDateRangeBookmarkFormat {
  const {from, offset, to} = comparisonDate;
  return {
    ...(from ? {from_date: from} : {}),
    ...(offset ? {offset} : {}),
    ...(to ? {to_date: to} : {}),
  };
}

export function comparisonDateFromBookmarkFormat(
  bookmarkComparisonDate: ComparisonDateRangeBookmarkFormat,
): ComparisonDate {
  const {from_date: from, offset, to_date: to} = bookmarkComparisonDate;
  if (offset) {
    return {offset};
  } else if (from || to) {
    return {
      ...(from ? {from} : {}),
      ...(to ? {to} : {}),
    };
  }
  return null;
}

export function getTimeComparisonRangeText(timeComparison: ComparisonDate & ComparisonDateRangeBookmarkFormat) {
  if (timeComparison.offset) {
    return `previous ${timeComparison.offset.unit}`;
  } else {
    // GOOT fix: sometimes we get from_date, where we used to only get from.
    // TODO: root cause why we use from_date vs from inconsistently
    const fromDate = timeComparison.from_date || timeComparison.from;
    const toDate = timeComparison.to_date || timeComparison.to;

    const rolling = DateRange.isRelativeDate(fromDate) || DateRange.isRelativeDate(toDate);
    return `date range ${fromDate ? `starting` : `ending`} on ${
      DateRange.convertBaseDateToCalendarDate(toDate) ?? DateRange.convertBaseDateToCalendarDate(fromDate)
    }${rolling ? ` (rolling)` : ``}`;
  }
}
